const STATUSES_LIST = [
  {
    id: 'pending',
  },
  {
    id: 'success',
  },
  {
    id: 'fail',
  },
  {
    id: 'confirm',
  },
  {
    id: 'cancelled',
  },
  {
    id: 'rejected',
  },
  {
    id: 'timeout',
  }
];

module.exports = {
  name: 'status',
  placeholder: 'Auction status',
  list: STATUSES_LIST
}